import { TableRowListCombinedProps } from './types';

const usePresenter = (props: TableRowListCombinedProps): TableRowListCombinedProps => {
  return props;
};

export default usePresenter;
